import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../../api";
import { Cancellation } from "../../../@types/cancellation";

export function useCancellationDetails(id: Cancellation["id"]) {
  const token = localStorage.getItem("gov_access_token_sso");

  return useQuery<Cancellation, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['cancellation', 'details', id],
    queryFn: async () => {
      const response = await apisiseci.get<Cancellation>(
        `/cms/cancelamentos/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
  });
}
